import { getLocationsByPostalCode } from '../util/api';

export const FETCH_LOCATION_REQUEST = 'app/locations/FETCH_LOCATION_REQUEST';
export const FETCH_LOCATION_SUCCESS = 'app/locations/FETCH_LOCATION_SUCCESS';
export const FETCH_LOCATION_FINISHED = 'app/locations/FETCH_LOCATION_FINISHED';

const initialState = {
    locations: {}, // { [CH-8000]: { city, canton } }
    locationsRequests: {}, // { [CH-8000]: true }
};

const locationKey = (countryCode, postalCode) =>
    `${countryCode}-${postalCode}`.trim().toUpperCase();

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case FETCH_LOCATION_REQUEST:
            return {
                ...state,
                locationsRequests: { ...state.locationsRequests, [payload.key]: true },
            };
        case FETCH_LOCATION_FINISHED: {
            const { [payload.key]: _, ...locationsRequests } = state.locationsRequests;
            return { ...state, locationsRequests };
        }
        case FETCH_LOCATION_SUCCESS:
            return {
                ...state,
                locations: { ...state.locations, [payload.key]: payload.location },
            };
        default:
            return state;
    }
}

export const fetchLocationRequest = key => ({
    type: FETCH_LOCATION_REQUEST,
    payload: { key },
});

export const fetchLocationFinished = key => ({
    type: FETCH_LOCATION_FINISHED,
    payload: { key },
});

export const fetchLocationSuccess = (key, location) => ({
    type: FETCH_LOCATION_SUCCESS,
    payload: { key, location },
});

/**
 * @returns {object|null} { city, canton } rows from /api/locations
 */
export const selectLocation = (state, countryCode, postalCode) =>
    countryCode && postalCode
        ? state.locations.locations[locationKey(countryCode, postalCode)] || null
        : null;

export const selectLocationRequestInProgress = (state, countryCode, postalCode) =>
    countryCode && postalCode
        ? Boolean(state.locations.locationsRequests[locationKey(countryCode, postalCode)])
        : false;

/**
 * Resolves city and canton by postal code, e.g. for the breadcrumbs of horse listings
 * and user profiles. Results are cached per country and postal code
 */
export const fetchLocation = (countryCode, postalCode) => async (dispatch, getState) => {
    if (!countryCode || !postalCode) return null;

    const cachedLocation = selectLocation(getState(), countryCode, postalCode);
    if (cachedLocation) return cachedLocation;

    const key = locationKey(countryCode, postalCode);

    dispatch(fetchLocationRequest(key));

    try {
        const response = await getLocationsByPostalCode(countryCode, postalCode);
        if (!response.ok) return null;

        const { data } = await response.json();
        const [city] = data?.cities || [];

        if (!city) return null;

        const location = { city, canton: city.canton };
        dispatch(fetchLocationSuccess(key, location));

        return location;
    } catch (e) {
        // breadcrumbs are not rendered without location
        return null;
    } finally {
        dispatch(fetchLocationFinished(key));
    }
};
